import { inputLabelClasses } from "@mui/material/InputLabel";

/**
 * Outlined input label at 1rem with `line-height: 1` and no letter-spacing,
 * 4px (empty) or 3px (shrunk) lower than MUI's default position.
 *
 * Interpolate it into an `InputLabel`'s `css`. The selectors repeat the class
 * so they beat MUI's own label styles.
 */
export const outlinedInputLabelStyles = `
  && {
    font-size: 1rem;
    line-height: 1;
    letter-spacing: normal;
  }
  &&.${inputLabelClasses.outlined} {
    transform: translate(14px, 20px) scale(1);
  }
  &&.${inputLabelClasses.outlined}.${inputLabelClasses.shrink} {
    transform: translate(14px, -6px) scale(0.75);
  }
`;
